export default __webpack_public_path__ + "static/media/pet_adoption_house.0cc57054.svg";